import React, { Component } from 'react';
import Report from './Report'

class Reports extends Component {

    render() {
        return(
            <div className="reports-wrapper" id="reports-wrapper">
                {this.props.scans.map(scan => {return <Report key={scan.timestamp} reportFields={scan}/>})}
            </div>
        );
    }
}

export default Reports;


// WEBPACK FOOTER //
// ./src/Reports.jsx